import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import "@/components/site/site.css";
import App from "@/App";

// Staff CRM: crm.vktours.com (served at "/") or /crm/* on any host. Lazy-loaded so the website bundle doesn't grow.
const isCrm = /^crm\./i.test(window.location.hostname) || /^\/crm(\/|$)/.test(window.location.pathname);
const CrmApp = lazy(() => import(/* webpackChunkName: "crm" */ "@/crm/CrmApp"));

// Remove the build-time SEO tags; react-helmet sets the live ones for each page
document.querySelectorAll("[data-pr]").forEach((n) => n.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {isCrm ? (
      <Suspense fallback={null}>
        <CrmApp />
      </Suspense>
    ) : (
      <HelmetProvider>
        <App />
      </HelmetProvider>
    )}
  </React.StrictMode>,
);
